import React, { useState } from "react";
import { Button, Select, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { getAllTenants } from "../../services/other";
import { setTenant } from "../../utils/tenant";
import classes from "./Tenants.module.scss";

const Tenants = () => {
    const navigate = useNavigate();
    const [selectedTenant, setSelectedTenant] = useState(null);

    const { data: tenants, isLoading } = useQuery({
        queryKey: ["tenants"],
        queryFn: getAllTenants,
    });

    if (isLoading) {
        return null;
    }

    function handleTenantChange(value) {
        const id = Number(value);
        const settings = tenants?.find((t) => t.id === id);
        const hasAllSettings =
            !!settings?.clientId && !!settings?.redirectUrl && !!settings?.realm;

        if (!hasAllSettings) {
            return;
        }

        setTenant(settings);
        setSelectedTenant(settings);
    }

    const selectData = tenants
        ? tenants.map((t) => ({ value: String(t.id), label: t.name }))
        : [];

    return (
        <div className={classes["tenants-box"]}>
            <div className={classes.card}>
                <Text size="md" fw={500} mb="sm">
                    Please select your organization:
                </Text>

                <Select
                    data={selectData}
                    placeholder="Select organization"
                    onChange={handleTenantChange}
                    classNames={{ option: classes.selectOption }}
                    mb="md"
                />

                <Button
                    fullWidth
                    disabled={!selectedTenant}
                    onClick={() => {
                        navigate("/");
                        window.location.reload();
                    }}
                >
                    Continue
                </Button>
            </div>
        </div>
    );
};

export default Tenants;
